module.exports = __webpack_public_path__ + "img/nossa-caixa.fa370e6c.svg";